import React, {PureComponent} from 'react';
import SelectBubble from '../../components/onboarding/SelectBubble';
import { MultComponentButton } from './OnboardingStyles';
import {answerBubbleStyle, answerBubbleStyleMobile} from '../../utils/styles';
import { isMobile } from "../../utils/util";
import * as zenscroll from 'zenscroll';


class SkinConcerns extends PureComponent {
    constructor(props) {
        super(props);

        this.handleDone = this.handleDone.bind(this);
        this.handleNotSure = this.handleNotSure.bind(this);
        this.handleOnclick = this.handleOnclick.bind(this);
        this.handleAllSelect = this.handleAllSelect.bind(this);

        this.concerns = [];
        this.concernIndices = [];

        this.concernsStr = '';
        this.itemsSelected = 0;

        this.state = {
            acneSelected:false,
            darkSpotsSelected:false,
            rednessSelected:false,
            wrinklesSelected:false,
            oilinessSelected:false,
            drynessSelected:false,
            cloggedPoresSelected:false,
            dullnessSelected:false,
            darkcirclesSelected:false,
            notSureSelected:false,
            finished: false,
            showText: this.props.showText,
        };
    }

    componentDidMount(){
        
        // let doneButton = document.querySelector(".skinConcerns-conten");
        // if (doneButton && isMobile(navigator.userAgent) ) doneButton.scrollIntoView();

        // 进度条
        try {
            if(this.props.fun_updateStage){
            var stage = this.props.stage;
            var stageSum = this.props.stageSum;
            if(stage && stageSum)
            this.props.fun_updateStage(parseInt(stage)-1,stageSum);
            }
        } catch (error) {
            console.error(error);
        }    

        setTimeout(() => {
            let doneButton = document.getElementById("skinConcerns-postion-top");
            if (doneButton ) doneButton.scrollIntoView();
        }, 500);

    }

   
    componentDidUpdate () {
      let doneButton = document.querySelector(".skinConcerns-conten");
      if (doneButton) doneButton.scrollIntoView();

        // let doneButton = document.getElementById("skinConcerns-postion-top");
        // if (doneButton ) doneButton.scrollIntoView(false);

    }


    handleDone() {
        if (this.itemsSelected > 0 || this.state.notSureSelected) {
            this.setState({ finished: true });
            try {
                let step = this.props.step;
                localStorage.setItem("doneQuizStepId",step.id);
            } catch (error) {
                console.error(error);
            }
            localStorage.setItem("SQ_concerns",this.concernIndices.join(", "));

            try {
                if(this.props.fun_updateStage){
                  var stage = this.props.stage;
                  var stageSum = this.props.stageSum;
                  if(stage && stageSum)
                  this.props.fun_updateStage(stage,stageSum);
                }
              } catch (error) {
                console.error(error);
            }

            this.concernsStr = this.concerns.join(", ");
            this.props.step.value = {value:this.concernIndices.join(", "), label: this.concerns.join(", ")  };
            this.props.triggerNextStep({ value: {value:this.concernIndices.join(", "), label: this.concerns.join(", ")  } });
           
        }else{
            alert("Please select an answer.");
        }
    }

    handleAllSelect(){
        this.itemsSelected = 9;
     
        this.concerns = [];
        this.concernIndices = [];
        this.removeItem({ index: 10, value: "Not sure" });

        this.addItem({ index: 1, value: "Acne" });
        this.addItem({ index: 2, value: "Dark Spots" });
        this.addItem({ index: 3, value: "Redness" });
        this.addItem({ index: 4, value: "Wrinkles" });
        this.addItem({ index: 5, value: "Oiliness" });
        this.addItem({ index: 6, value: "Dryness" });
        this.addItem({ index: 7, value: "Clogged Pores" });
        this.addItem({ index: 8, value: "Dullness" });
        this.addItem({ index: 9, value: "Dark Circles" });

        this.setState({
            acneSelected:true,
            darkSpotsSelected:true,
            rednessSelected:true,
            wrinklesSelected:true,
            oilinessSelected:true,
            drynessSelected:true,
            cloggedPoresSelected:true,
            dullnessSelected:true,
            darkcirclesSelected:true
        });
    }

    handleNotSure() {

        this.concerns = [];
        this.concernIndices = [];
        this.itemsSelected = 0;

        this.setState({
            acneSelected:false,
            darkSpotsSelected:false,
            rednessSelected:false,
            wrinklesSelected:false,
            oilinessSelected:false,
            drynessSelected:false,
            cloggedPoresSelected:false,
            dullnessSelected:false,
            darkcirclesSelected:false
        });

        let selected = !this.state.notSureSelected;
        this.setState((prevState, props) => ({
            notSureSelected: !prevState.notSureSelected
        }));

        if (selected) {
            this.addItem({ index: 10, value: "Not sure" });
        } else {
            this.removeItem({ index: 10, value: "Not sure" });
        }
    }

    removeItem(answer) {
        let index = this.concerns.indexOf(answer.value);
        if (index > -1) {
            this.concerns.splice(index, 1);
        }
        index = this.concernIndices.indexOf(answer.index);
        if (index > -1) {
            this.concernIndices.splice(index, 1);
        }
    }

    addItem(answer) {
        let index = this.concerns.indexOf(answer.value);
        if (index === -1) {
            this.concerns.push(answer.value);
        }
        index = this.concernIndices.indexOf(answer.index);
        if (index === -1) {
            this.concernIndices.push(answer.index);
        }
    }

    handleOnclick(target) {

        // if (this.state.notSureSelected) {
        //     this.itemsSelected = 0;
        //     this.concerns = [];
        //     this.concernIndices = [];

        //     this.setState({
        //         notSureSelected: false
        //     });
        //     return;
        // }

        if (this.state.notSureSelected) {
            this.removeItem({ index: 10, value: "Not sure" });
            this.setState((prevState, props) => ({
                notSureSelected: !prevState.notSureSelected
            }));
        }

        if (target === "acneSelected") {
            let selected = !this.state.acneSelected;

            this.setState((prevState, props) => ({
                acneSelected: !prevState.acneSelected
            }));

            if (selected) {
                this.itemsSelected++;
                this.addItem({ index: 1, value: "Acne" });
            } else {
                this.itemsSelected--;
                this.removeItem({ index: 1, value: "Acne" });
            }
        }

        if (target === "darkSpotsSelected") {
            let selected = !this.state.darkSpotsSelected;

            this.setState((prevState, props) => ({
                darkSpotsSelected: !prevState.darkSpotsSelected
            }));

            if (selected) {
                this.itemsSelected++;
                this.addItem({ index: 2, value: "Dark Spots" });
            } else {
                this.itemsSelected--;
                this.removeItem({ index: 2, value: "Dark Spots" });
            }
        }

        if (target === "rednessSelected") {
            let selected = !this.state.rednessSelected;

            this.setState((prevState, props) => ({
                rednessSelected: !prevState.rednessSelected
            }));

            if (selected) {
                this.itemsSelected++;
                this.addItem({ index: 3, value: "Redness" });
            } else {
                this.itemsSelected--;
                this.removeItem({ index: 3, value: "Redness" });
            }
        }

        if (target === "wrinklesSelected") {
            let selected = !this.state.wrinklesSelected;

            this.setState((prevState, props) => ({
                wrinklesSelected: !prevState.wrinklesSelected
            }));

            if (selected) {
                this.itemsSelected++;
                this.addItem({ index: 4, value: "Wrinkles" });
            } else {
                this.itemsSelected--;
                this.removeItem({ index: 4, value: "Wrinkles" });
            }
        }

        if (target === "oilinessSelected") {
            let selected = !this.state.oilinessSelected;

            this.setState((prevState, props) => ({
                oilinessSelected: !prevState.oilinessSelected
            }));

            if (selected) {
                this.itemsSelected++;
                this.addItem({ index: 5, value: "Oiliness" });
            } else {
                this.itemsSelected--;
                this.removeItem({ index: 5, value: "Oiliness" });
            }
        }

        if (target === "drynessSelected") {
            let selected = !this.state.drynessSelected;

            this.setState((prevState, props) => ({
                drynessSelected: !prevState.drynessSelected
            }));

            if (selected) {
                this.itemsSelected++;
                this.addItem({ index: 6, value: "Dryness" });
            } else {
                this.itemsSelected--;
                this.removeItem({ index: 6, value: "Dryness" });
            }
        }

        if (target === "cloggedPoresSelected") {
            let selected = !this.state.cloggedPoresSelected;

            this.setState((prevState, props) => ({
                cloggedPoresSelected: !prevState.cloggedPoresSelected
            }));

            if (selected) {
                this.itemsSelected++;
                this.addItem({ index: 7, value: "Clogged Pores" });
            } else {
                this.itemsSelected--;
                this.removeItem({ index: 7, value: "Clogged Pores" });
            }
        }

        if (target === "dullnessSelected") {
            let selected = !this.state.dullnessSelected;

            this.setState((prevState, props) => ({
                dullnessSelected: !prevState.dullnessSelected
            }));

            if (selected) {
                this.itemsSelected++;
                this.addItem({ index: 8, value: "Dullness" });
            } else {
                this.itemsSelected--;
                this.removeItem({ index: 8, value: "Dullness" });
            }
        }

        if (target === "darkcirclesSelected") {
            let selected = !this.state.darkcirclesSelected;

            this.setState((prevState, props) => ({
                darkcirclesSelected: !prevState.darkcirclesSelected
            }));

            if (selected) {
                this.itemsSelected++;
                this.addItem({ index: 9, value: "Dark Circles" });
            } else {
                this.itemsSelected--;
                this.removeItem({ index: 9, value: "Dark Circles" });
            }
        }
    }

    handleClassName(target) {
        let bubbleClassName = "multiselect-component__selectable"
        if (target !== "notSureSelected") {
            if (this.state.notSureSelected) bubbleClassName = bubbleClassName;
            else if(this.state[target]) bubbleClassName = bubbleClassName + " selected"; 
        } else {
            if (this.itemsSelected > 0) bubbleClassName = bubbleClassName;
            else if (this.state[target]) bubbleClassName = bubbleClassName + " selected"; 
        }
        return bubbleClassName;
    }

    renderConcerns(){
        return (
            <div className="onb-item-container skinConcerns-conten" id="skinConcerns-conten">
                <div className="onb-text-conten">{this.state.showText}</div>

                <div className="onb-se-allBut">Select all that apply</div>
                
                <div className='container question-component__inner skin-concerns-question-component__inner'>
                    <div data-tip="Select your concerns" className="multiselect-component multiselect-component_display-as-bubbles">
                        <SelectBubble
                            item="Acne"
                            selected={this.state.acneSelected}
                            className={this.handleClassName("acneSelected")}
                            handleOnClick={this.handleOnclick}
                            typeSelected="acneSelected" 
                            path='/images/onboarding/skincons/acne.svg'
                        />

                        <SelectBubble
                            item="Dark Spots"
                            selected={this.state.darkSpotsSelected}
                            className={this.handleClassName("darkSpotsSelected")}
                            handleOnClick={this.handleOnclick}
                            typeSelected="darkSpotsSelected" 
                            path='/images/onboarding/skincons/dark-spots.svg'
                        />

                        <SelectBubble
                            item="Redness"
                            selected={this.state.rednessSelected}
                            className={this.handleClassName("rednessSelected")}
                            handleOnClick={this.handleOnclick}
                            typeSelected="rednessSelected" 
                            path='/images/onboarding/skincons/redness.svg'
                        />

                        <SelectBubble
                            item="Wrinkles"
                            selected={this.state.wrinklesSelected}
                            className={this.handleClassName("wrinklesSelected")}
                            handleOnClick={this.handleOnclick}
                            typeSelected="wrinklesSelected"  
                            path='/images/onboarding/skincons/wrinkles.svg'
                        />
                        <SelectBubble
                            item="Oiliness"
                            selected={this.state.oilinessSelected}
                            className={this.handleClassName("oilinessSelected")}
                            handleOnClick={this.handleOnclick}
                            typeSelected="oilinessSelected" 
                            path='/images/onboarding/skincons/oiliness.svg'
                        />

                        <SelectBubble
                            item="Dryness"
                            selected={this.state.drynessSelected}
                            className={this.handleClassName("drynessSelected")}
                            handleOnClick={this.handleOnclick}
                            typeSelected="drynessSelected" 
                            path='/images/onboarding/skincons/dryness.svg' 
                        />

                        <SelectBubble
                            item="Clogged Pores"
                            selected={this.state.cloggedPoresSelected}
                            className={this.handleClassName("cloggedPoresSelected")}
                            handleOnClick={this.handleOnclick}
                            typeSelected="cloggedPoresSelected" 
                            path='/images/onboarding/skincons/clogged-pores.svg'
                        />

                        <SelectBubble
                            item="Dullness"
                            selected={this.state.dullnessSelected}
                            className={this.handleClassName("dullnessSelected")}
                            handleOnClick={this.handleOnclick}
                            typeSelected="dullnessSelected" 
                            path='/images/onboarding/skincons/dullness.svg'
                        />

                        <SelectBubble
                            item="Dark Circles / Puffiness"
                            selected={this.state.darkcirclesSelected}
                            className={this.handleClassName("darkcirclesSelected")}
                            handleOnClick={this.handleOnclick}
                            typeSelected="darkcirclesSelected"  
                            path='/images/onboarding/skincons/dark-circles.svg'
                        />

                        <SelectBubble
                            item="Not Sure"
                            selected={this.state.notSureSelected}
                            className={this.handleClassName("notSureSelected")}
                            handleOnClick={this.handleNotSure} 
                            path='/images/onboarding/skincons/not-sure.svg'

                        />
                    </div>
                </div>
                <button className="p-a-n-button submit-but" onClick={this.handleDone}>Continue</button>
            </div>  
        )
    }

    render() {
        if (this.state.finished) {
            return (
                <div className="onb-item-container">
                    <div className="onb-text-conten">{this.state.showText}</div>
                </div>
            );
        } else {
            return (<div style={{margin: '1px auto'}} className={this.state.finished ? 'rsc-ts sc-dnqmqq' : null}>{this.renderConcerns()}</div>)

        }
    }
}

export default SkinConcerns;



// WEBPACK FOOTER //
// ./src/views/onboarding/SkinConcerns.js